const defaultSettings = require('../settings')
// 本地环境配置
module.exports = {
  title: defaultSettings.title || 'xxh-zhaopin-web',
  port: 9018, // 端口
  baseFileUrl: 'https://uatin-gw.DOMAIN_NAME', // 文件服务
  baseUrl: 'https://uat-ihire.dhrforce.com/', // 项目地址
  // baseApi: 'https://prein-gw.DOMAIN_NAME', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  baseApi: 'https://portaluat.dhrforce.com',
  loginUrl: 'https://portaluat.dhrforce.com/login',
  baseSiteCdn: 'https://sitecdn.71360.com',
  referralPth: 'https://uat-ihire.dhrforce.com/referral',
  referralH5Path:'https://uat-ihire-app.dhrforce.com/referral', // 内推H5
  extrapolationH5Path: 'https://uat-ihire-app.dhrforce.com/extrapolation', // 外推H5
  extrapolationPCPath: 'https://uat-ihire.dhrforce.com/extrapolation', // 外推pc
  recruitPath: 'https://uat-ihire-app.dhrforce.com', // 招聘助手H5
  filePathPrefix: 'https://zzp-public-1318723636.cos.ap-shanghai.myqcloud.com', // 文件地址前缀
  campusAmbassadorPCPath: 'https://uat-ihire.dhrforce.com/campusAmbassador', // 校园大使PC
  campusAmbassadorH5Path: 'https://uat-ihire-app.dhrforce.com/campusAmbassador', // 校园大使H5
  BPMPath: 'https://uat-bpm.dhrforce.com/#/' // BPM审批中心pc项目
}

